<template>
  <section class="container">
    <!-- 费用 -->
    <section class="cost_box">
      <section class="title_box">
        <span class="xin">*</span>
        <span class="text">费用</span>
      </section>
      <section class="input_box">
        <span>¥</span>
        <input type="number" placeholder="请输入价格" v-model="price" @blur="blur"/>
      </section>
    </section>
    <!-- 上传现场照片 -->
    <section class="cost_box pic_box">
      <section class="title_box">
        <span class="xin">*</span>
        <span class="text">上传现场照片</span>
      </section>
      <section class="img_box">
        <section class="img_item img_b" v-for="(item,index) in imgs" :key="item.imgUrl">
          <img class="img" @click="viewBigPic(item.imgUrl)" :src="item.imgUrl" alt="">
          <img class="deleteFile" @click.stop="deleteFile(index)" src="../../assets/images/btn_clear.png"/>
        </section>
        <section class="img_item" v-if="imgs.length != 9">
          <div class="item_center_inp" style="opacity:0;">
            <upload-img @uploadImg="uploadImg" :multiple="true"></upload-img>
          </div>
          <img class="add_icon" src="../../assets/images/btn_add_photo.png" />
        </section>
      </section>
    </section>
    <!-- 备注 -->
    <!-- <section class="remarks">
      <p>备注</p>
      <textarea placeholder="请输入"></textarea>
    </section> -->
    <section class="footer_h"></section>
    <common-footer class="button">
      <mt-button class="footer_btn btn_default" @click="surecost">确认费用</mt-button>
    </common-footer>
    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary :imgs="bigImgs" :curIndex="curIndex" v-show="showGallary" @close="handleGallaryClose"></common-gallary>
    </fade-animation>
  </section>
</template>

<script>
import commonFooter from "../../components/commonFooter";
import uploadImg from '../../components/uploadImg';
import util from "../../utils/util";
import CommonGallary from "../../components/Gallary";
import FadeAnimation from "../../components/FadeAnimation";
import { updateIntServOrder } from "../../utils/api";
export default {
  name: "costEvaluate",
  components: {
    commonFooter,
    uploadImg,
    CommonGallary,
    FadeAnimation
  },
  data() {
    return {
      price:'',
      imgs:[],
      bigImgs:[],
      curIndex:0,
      prevAmount:'',
      workerId:'',
      showGallary:false
    };
  },
  created(){
    if(this.$route.query.price){
      this.price = this.$route.query.price;
      this.prevAmount = this.$route.query.price;
      this.workerId = this.$route.query.workerId;
      this.imgs = JSON.parse(window.localStorage.getItem('imgs') || '[]');
      window.localStorage.removeItem('imgs')
    }

  },
  methods: {
    handleGallaryClose() {
      this.showGallary = false;
    },
    viewBigPic(imgPath) {
      this.bigImgs.forEach((item,index)=>{
        if(item === imgPath){
          this.curIndex = index
          this.showGallary = true
        }
      })
    },
    blur(){
      if(this.price){
        this.price = Number(this.price).toFixed(2)
      }
    },
    uploadImg (val) {
      this.imgs.push({"imgUrl":val.imgUrl,"type":'1'})
      this.bigImgs.push(val.imgUrl)
    },
    deleteFile(index){
      this.imgs.splice(index,1)
      this.bigImgs.splice(index,1)
    },
    surecost(){
      if(!this.price){
        util.showToast("请输入费用")
        return false;
      }
      if(Number(this.price)<=0){
        util.showToast("请输入正确的费用")
        return false;
      }
      if(this.imgs.length === 0){
        util.showToast("请上传现场照片")
        return false;
      }
      let params = {
          id:this.$route.query.id,
          orderId:this.$route.query.orderId,
          status:'0',//待支付
          imgs:this.imgs,
          totalPrice:this.price
        }
        if(this.$route.query.price){
          params.prevAmount = this.prevAmount;
          params.workerId = this.workerId;
        }
        let header = {}
        if(this.$route.query.marketid){
          header.marketId = this.$route.query.marketid
        }
        if(this.$route.query.cityId){
          header.cityId = this.$route.query.cityId
        }
        util.showLoading()
        updateIntServOrder(params,header).then(res=>{
          console.log(res)
          util.hideLoading()
          if(res.res.code === 10000){
            util.showToast('操作成功')
            this.$router.go(-1)
          }else{
            util.showToast(res.res.msg)
          }
        })
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  background: #eee;
}
.cost_box {
  background: #fff;
  padding: 28px 20px;
  margin-bottom: 14px;
  .title_box {
    .flex();
    height: 40px;
    align-items: center;
    margin-bottom: 10px;
    .xin {
      color: #fc3f56;
      font-size: 28px;
      display: block;
      margin-right: 4px;
    }
    .text {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .input_box {
    .flex();
    height: 84px;
    align-items: center;
    flex-wrap: nowrap;
    span {
      font-size: 32px;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
      margin-right: 20px;
      display: block;
    }
    input {
      height: 100%;
      flex: 1;
      font-size: 40px;
      color: #333;
      font-weight: bold;
    }
  }
  .img_box {
    width: 100%;
    .flex();
    .img_item {
      width: 160px;
      height: 160px;
      background: rgba(244, 244, 244, 1);
      border-radius: 8px;
      margin-right:28px;
      margin-bottom:28px;
      .flex();
      align-items: center;
      justify-content: center;
      position:relative;
      .img{
        width:160px;height:160px;
        border-radius: 8px;
        overflow: hidden;
        display: block;
      }
      .deleteFile{
        position: absolute;
        right: -25px;
        top: -25px;
        width: 50px;
        height: 50px;
      }
      .add_icon{
        display: block;
        width:32px;
        height:32px;
      }
    }
    .img_b{
      background:#fff;
    }
    .item_center_inp {
        position: absolute;left:0;right:0;top:0;bottom:0;
    }
  }
}
.pic_box{
  padding-bottom:0;
  .title_box{
    margin-bottom: 28px;
  }
}
.footer_h {
  width: 100%;
  height: 108px;
}
// 备注
.remarks {
  background: #fff;
  margin-bottom: 120px;
  padding: 28px 30px;
  p {
    height: 40px;
    font-size: 28px;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;
    margin-bottom: 14px;
  }
  textarea {
    display: block;
    font-size: 28px;
    min-height: 172px;
    width: 100%;
  }
}
.footer_btn {
  width: 100%;
  color: #fff;
  border-radius: 4px;
  background: @color17;
  font-size: 32px;
}
</style>